import { useMemo } from "react";
import { useGetNationalityList } from "@/api/services/global/master";
import { useGetListCompanyByRso } from "@/api/services/main/company";
import { useInitSetup } from "@/providers/InitSetupProvider";
import { USER_TYPE } from "@/types/enum";
import { TOption } from "@/types/common";
import { PROCEDURE_STATUS_LABELS } from "@/api/services/main/exam-steps/dtos/get-exam-step-learners.dto";

export const useExamStepsFilterMasterData = () => {
  const { userType } = useInitSetup();
  // Only RSO users can filter by 所属機関 — gate both the field and the company API call on this.
  const isRsoUser = userType === USER_TYPE.RSO_USER;

  const { nationalityOptions } = useGetNationalityList();
  const { data: companyData } = useGetListCompanyByRso(isRsoUser);

  const companyOptions = useMemo<TOption[]>(() => {
    const companies = companyData?.data ?? [];
    return companies.filter((c) => !c.isArchive).map((c) => ({ value: String(c.id), label: c.companyName }));
  }, [companyData]);

  const nationalityStringOptions = useMemo<TOption[]>(
    () => nationalityOptions.map((opt) => ({ ...opt, value: String(opt.value) })),
    [nationalityOptions],
  );

  return {
    canFilterByOrganization: isRsoUser,
    options: {
      organization: companyOptions,
      nationality: nationalityStringOptions,
      procedureStatus: PROCEDURE_STATUS_LABELS,
    },
  };
};
